export default "__VITE_ASSET__BW_yYM$s__"